export default {
  component: () => import('./page.vue'),
  path: '/messages',
  name: 'messages',
  meta: {
    title: '消息中心',
    auth: true,
  },
};
